module.exports = __webpack_public_path__ + "img/MircomLogo.b09d6450.jpg";